import { Link } from 'react-router-dom';
import { Users, Image as ImageIcon, LayoutDashboard, FolderOpen, LogOut, ShieldCheck } from 'lucide-react';
import { logoutAdmin } from './adminApi';

const MODULES = [
  { key: 'clients', title: 'Slider de clientes', desc: 'Subir logotipos, ajustar ancho, ordenar y controlar velocidad del carrusel.', to: '/admin/clientes', icon: Users, status: 'Activo' },
  { key: 'nosotros', title: 'Galería Nosotros', desc: 'Subir fotos del equipo con optimización automática de peso.', to: '/admin/nosotros', icon: ImageIcon, status: 'Activo' },
  { key: 'servicios', title: 'Banners de servicios', desc: 'Editar textos, imagen de fondo y enlace de cada categoría.', to: '/admin/servicios', icon: LayoutDashboard, status: 'Activo' },
  { key: 'proyectos', title: 'Proyectos / Galerías', desc: 'CRUD completo: crear, editar, eliminar galerías y sus fotos.', to: '/admin/proyectos', icon: FolderOpen, status: 'Activo' },
];

export default function AdminDashboard() {
  const onLogout = () => { logoutAdmin(); window.location.href = '/admin/login'; };
  return (
    <div className="min-h-screen bg-[#f4f5f7]" data-testid="admin-dashboard-page">
      {/* Top bar */}
      <header className="bg-white border-b border-[#58677A]/10 sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg bg-[#ED6B24]/10 flex items-center justify-center"><ShieldCheck className="text-[#ED6B24]" size={18} /></div>
            <div>
              <p className="text-[15px] font-bold text-[#58677A] leading-tight" style={{fontFamily:'Gotham,sans-serif'}}>Panel de administración</p>
              <p className="text-[11px] text-[#58677A]/60">Link Consultores</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Link to="/" target="_blank" rel="noopener" className="text-xs text-[#58677A] hover:text-[#ED6B24] px-3 py-1.5 rounded-md hover:bg-[#ED6B24]/10 transition" data-testid="admin-view-site">Ver sitio ↗</Link>
            <button onClick={onLogout} className="inline-flex items-center gap-1.5 text-xs text-[#58677A] hover:text-red-600 px-3 py-1.5 rounded-md hover:bg-red-50 transition" data-testid="admin-logout"><LogOut size={13}/> Salir</button>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="mb-8">
          <h1 className="text-2xl sm:text-3xl font-black text-[#58677A]" style={{fontFamily:'Gotham,sans-serif'}}>Bienvenido</h1>
          <p className="text-sm text-[#58677A]/70 mt-1">Selecciona un módulo para gestionar contenido del sitio público.</p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
          {MODULES.map((m) => (
            <Link key={m.key} to={m.to} className="group bg-white rounded-2xl p-5 sm:p-6 border border-[#58677A]/10 hover:border-[#ED6B24]/50 hover:shadow-[0_10px_30px_rgba(0,0,0,0.05)] transition-all" data-testid={`admin-module-${m.key}`}>
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-[#ED6B24]/10 text-[#ED6B24] flex items-center justify-center group-hover:bg-[#ED6B24] group-hover:text-white transition"><m.icon size={20} /></div>
                <div className="flex-1 min-w-0">
                  <h2 className="text-base sm:text-lg font-bold text-[#58677A]" style={{fontFamily:'Gotham,sans-serif'}}>{m.title}</h2>
                  <p className="text-sm text-[#58677A]/70 mt-1 leading-snug">{m.desc}</p>
                  <span className="inline-block mt-3 text-[10px] uppercase tracking-wider font-bold text-[#ED6B24] bg-[#ED6B24]/10 rounded-full px-2 py-0.5">{m.status}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 bg-white rounded-xl p-5 border border-[#58677A]/10">
          <p className="text-xs text-[#58677A]/70 leading-relaxed"><strong>Nota:</strong> Los cambios que guardes desde este panel se reflejan en vivo automáticamente en el sitio público. Cierra sesión al terminar por seguridad.</p>
        </div>
      </main>
    </div>
  );
}
